import { Components, Theme } from '@mui/material';

const muiOutlinedInput: Components<Theme>['MuiOutlinedInput'] = {
	styleOverrides: {
		root: ({ theme }) => ({
			borderRadius: 50,
			...theme.typography.input,
		}),
		notchedOutline: {
			borderColor: 'rgba(0,0,0,0.15)',
		},
		multiline: {
			borderRadius: 10,
		},
	},
};
export default muiOutlinedInput;
